"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from "react";
import { useLivePersonalizedEntry } from "@/lib/contentful/useLivePersonalizedEntry";
import type { VariantData } from "@/lib/ninetailed/mapEntryExperiences";
export interface PersonalizedViewProps<TFields> {
  fields: TFields;
  inspectorProps: (fieldId: string) => Record<string, string> | undefined;
}
interface Props<TFields> {
  variant: VariantData<TFields>;
  view: ComponentType<PersonalizedViewProps<TFields>>;
}

/**
 * Reusable across every personalized content type. Wraps a presentational `view` so the arm
 * selected for the visitor is live-editable in Contentful draft mode (live updates +
 * click-to-edit inspector) and renders plainly otherwise. The view reads `fields` and binds
 * `inspectorProps(fieldId)` on whichever fields should be click-to-edit; it owns any gating.
 */
export function LivePersonalizedEntry(t0) {
  const $ = _c(3);
  const {
    variant,
    view: View
  } = t0;
  const live = useLivePersonalizedEntry(variant);
  let t1;
  if ($[0] !== View || $[1] !== live) {
    t1 = <View {...live} />;
    $[0] = View;
    $[1] = live;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}